<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.intgat_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.intgat_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 15%">Status FTP</th>
                                <th style="width: 15%">Status Email</th>
                                <th style="width: 15%">Status API</th>
                                <th style="width: 15%">Status XML</th>
                                <th style="width: 15%">Status Json</th>
                                <th style="width: 15%">Status Txt</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_ftp.valor==1">{{ rowData.status_ftp.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_ftp.valor==2">{{ rowData.status_ftp.descr }}</span>
                                 </td>
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_email.valor==1">{{ rowData.status_email.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_email.valor==2">{{ rowData.status_email.descr }}</span>
                                 </td>
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_api.valor==1">{{ rowData.status_api.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_api.valor==2">{{ rowData.status_api.descr }}</span>
                                 </td>
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_xml.valor==1">{{ rowData.status_xml.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_xml.valor==2">{{ rowData.status_xml.descr }}</span>
                                 </td>
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_json.valor==1">{{ rowData.status_json.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_json.valor==2">{{ rowData.status_json.descr }}</span>
                                 </td>
                                 <td>
                                     <span class="badge badge-success" v-if="rowData.status_txt.valor==1">{{ rowData.status_txt.descr }}</span>
                                     <span class="badge badge-danger" v-if="rowData.status_txt.valor==2">{{ rowData.status_txt.descr }}</span>
                                 </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
  </template>

  <script>
  export default {
      data () {
        return {
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
  }
  </script>
